import { Person } from 'components/icons';
import { Avatar as KitAvatar, AvatarFallback, AvatarImage } from 'components/ui/avatar';
import { ComponentProps, ReactNode } from 'react';
import { cn } from 'utils/cn';

const SHAPE = {
    circular: 'rounded-full after:rounded-full',
    rounded: 'rounded-sm after:rounded-sm',
    square: 'rounded-none after:rounded-none',
} as const;

export interface Props extends Omit<ComponentProps<typeof KitAvatar>, 'className' | 'children'> {
    variant?: keyof typeof SHAPE;
    src?: string;
    alt?: string;
    className?: string;
    /** Shown while there is no image, or while it loads. Without any, a person glyph fills 75% of the avatar. */
    children?: ReactNode;
}

export default function Avatar({ variant = 'circular', src, alt, className, children, ...others }: Props) {
    return (
        <KitAvatar
            className={cn('bg-muted text-muted-foreground size-10 text-base', SHAPE[variant], className)}
            {...others}
        >
            {src ? <AvatarImage src={src} alt={alt} className={SHAPE[variant]} /> : null}
            <AvatarFallback className={cn('bg-transparent text-[length:inherit] text-[color:inherit]', SHAPE[variant])}>
                {children || children === 0 ? children : <Person className="size-3/4" />}
            </AvatarFallback>
        </KitAvatar>
    );
}
